import {bundle, Inject, Injectable} from "ng-metadata/core";
import {FacetsTransformer} from "./facetTransformation.module";
import {InactiveFacetsTransformationsModule} from "./inactiveFacetsTransformations/inactiveFacetsTransformations.module";

@Injectable()
export class InactiveFacetsTransformationService{
    private activeFacetListTransformers: [FacetsTransformer] | undefined[] = [] ;
    constructor(@Inject('$injector') private injector: ng.auto.IInjectorService){
        let module= bundle(InactiveFacetsTransformationsModule);
        // @ts-ignore
        for (let service of module._invokeQueue){ //load all transformer services
            // @ts-ignore
            this.activeFacetListTransformers.push(injector.get(service[2][0]));
        }
    }

    public async transformInactiveFacets(activeFacets){
        for (let facetTransformer of this.activeFacetListTransformers){
            activeFacets = await facetTransformer.transform(activeFacets);
        }
        return activeFacets;
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/facet/facetsTransformation/inactiveFacetsTransformation.service.ts